module.exports = __webpack_public_path__ + "./fonts/PPAgrandir-Regular.otf";